import React from 'react';
import { useTranslation } from 'react-i18next';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';

function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '-';
  }

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? raw : date.toLocaleString();
}

function getStatusBadgeClass(status) {
  const normalized = String(status || '').trim().toLowerCase();
  if (normalized === 'closed') {
    return 'bg-success-subtle text-success';
  }
  if (normalized === 'reported') {
    return 'bg-warning-subtle text-warning';
  }
  return 'bg-danger-subtle text-danger';
}

function ComplianceBreachPageView({
  items,
  isLoading,
  isSubmitting,
  form,
  error,
  success,
  onFormChange,
  submitCreate,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <FloatingAlerts error={error} success={success} />
      <PageHeader title={t('complianceBreach.title')} subtitle={t('complianceBreach.subtitle')} />

      <div className="row g-3">
        <div className="col-xl-4">
          <div className="card card-body">
            <h5 className="mb-3">{t('complianceBreach.createIncident')}</h5>
            <form onSubmit={submitCreate}>
              <div className="mb-3">
                <label className="form-label">{t('complianceBreach.labelTitle')}</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.title}
                  onChange={(event) => onFormChange('title', event.target.value)}
                  disabled={isSubmitting}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">{t('complianceBreach.labelDiscoveredAt')}</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={form.discoveredAt}
                  onChange={(event) => onFormChange('discoveredAt', event.target.value)}
                  disabled={isSubmitting}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">{t('complianceBreach.labelDetails')}</label>
                <textarea
                  className="form-control"
                  rows={5}
                  value={form.details}
                  onChange={(event) => onFormChange('details', event.target.value)}
                  disabled={isSubmitting}
                />
              </div>
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? t('complianceBreach.creating') : t('complianceBreach.createIncidentButton')}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="col-xl-8">
          <div className="card card-body">
            {isLoading ? <div className="text-muted">{t('complianceBreach.loading')}</div> : null}
            {!isLoading && items.length === 0 ? <div className="text-muted">{t('complianceBreach.noIncidents')}</div> : null}
            {!isLoading && items.length > 0 ? (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>{t('complianceBreach.colTitle')}</th>
                      <th>{t('complianceBreach.colStatus')}</th>
                      <th>{t('complianceBreach.colDiscovered')}</th>
                      <th>{t('complianceBreach.colIcoDeadline')}</th>
                      <th>{t('complianceBreach.colReported')}</th>
                      <th>{t('complianceBreach.colCreatedBy')}</th>
                      <th>{t('complianceBreach.colDetails')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.uid || `${item.title}-${item.created}`}>
                        <td>{item.title || '-'}</td>
                        <td>
                          <span className={`badge rounded-pill fw-semibold text-uppercase ${getStatusBadgeClass(item.status)}`}>
                            {item.status || '-'}
                          </span>
                        </td>
                        <td>{formatDate(item.discoveredAt)}</td>
                        <td>{formatDate(item.icoDeadlineAt)}</td>
                        <td>{formatDate(item.reportedAt)}</td>
                        <td>{item.createdByEmail || '-'}</td>
                        <td className="text-break">{item.details || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComplianceBreachPageView;
